import React from "react";
import WebHostingHero from "../components/web-hosting/WebHostingHero";
import WebHostingValue from "../components/web-hosting/WebHostingValue";
import WebHostingPlans from "../components/web-hosting/WebHostingPlans";
import WebHostingFAQ from "../components/web-hosting/WebHostingFAQ";
import WebHostingCTA from "../components/web-hosting/WebHostingCTA";

export default function WebHostingPage() {
  return (
    <>
      <WebHostingHero />
      <WebHostingValue />
      <WebHostingPlans />
      <WebHostingFAQ />
      <WebHostingCTA />
    </>
  );
}
